import { getTeamUserRoleLabel } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamUserRole } from "@shaarp/common";

export default function DataTableCellAdminUserTeamRole({
  role,
}: {
  role: TeamUserRole;
}) {
  const { t } = useTranslation();
  return <span>{getTeamUserRoleLabel(role, t)}</span>;
}
